import Project from "src/api/project";
const ColumnIndexedTypes = Project.COLUMN_INDEXED_TYPES;
export const DISABLED_TYPES = [
    Project.COLUMN_LABELED_TYPES.get('IGNORE')
];
export const makeExtraTypeOptions = function (fields) {
    const desc = 'This column is being used as the source for a remapped column, therefore it cannot have this data type';
    const options = new Map(DISABLED_TYPES.map(t => [t, { disabled: true, showTooltip: true, tooltipDescription: desc }]));
    return new Map(fields.map(f => [f, options]));
};
